<template>
<v-card  color="transparent">
			<v-card-text>
				<v-list nav dark tile class="elevation-1 opaqueBlueBg">
					<v-list-item>
						<div class="d-flex mx-auto" style="width: 200px">
							<v-img
								:src="require('@/assets/primar-textlogo.png')"
								alt="PRIMAR logo"
								contain
								width="200px"
								@click="$router.push('/')"
								style="cursor: pointer"
							/>
						</div>
					</v-list-item>

					<v-list-item v-for="link in routes" :key="link.path" :to="link.path">
						<v-list-item-icon>
							<v-icon color="secondary">{{ link.meta.icon }}</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title v-text="link.meta.title" />
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-card-text>
		</v-card>
</template>

<script>

export default {
	props: {
		routes: Array
	}
}
</script>
